import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatTreeModule } from '@angular/material/tree';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { DateAdapter, MatNativeDateModule, NativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import {
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule,
} from '@angular-material-components/datetime-picker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { TreeModule } from 'primeng/tree';
import { DropdownModule } from 'primeng/dropdown';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HomeRoutingModule } from './home-routing.module';
import { MaterialModule } from 'src/app/material-module';
import { HomeComponent } from './home/home.component';
import { PlantModelComponent } from './home/plant-model/plant-model.component';
import { OeeConfigurationComponent } from '../O3AdministrationComponents/ManufacturingAdminComponents/oee-configuration/oee-configuration.component';
import { OrderProcessingComponent } from '../ProductionOrderComponents/order-processing/order-processing.component';
import { ShopFloorDataComponent } from '../ProductionOrderComponents/shop-floor-data/shop-floor-data.component';
import { SfdcConfigurationComponent } from '../O3AdministrationComponents/ManufacturingAdminComponents/sfdc-configuration/sfdc-configuration.component';
import { MachineboardComponent } from './analytics/machineboard/machineboard.component';
import { MachineParametersComponent } from '../O3AdministrationComponents/ManufacturingAdminComponents/machine-parameters/machine-parameters.component';
import { CrewSchedulingComponent } from '../O3AdministrationComponents/GeneralSettingComponents/crew-scheduling/crew-scheduling.component';
import { UseraccessComponent } from './home/useraccess/useraccess.component';
import { AvailabilityAnalysisComponent } from './availability-analysis/availability-analysis.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { QualityAnalysisComponent } from './quality-analysis/quality-analysis.component';
import { SafetyDbComponent } from './safety-db/safety-db.component';
import { CuAnalysisComponent } from './cu-analysis/cu-analysis.component';
import { GeneralAreaComponent } from '../General Category/general-area/general-area.component';
import { GeneralDepartmentComponent } from '../General Category/general-department/general-department.component';
import { GeneralShiftComponent } from '../General Category/general-shift/general-shift.component';
import { QualityDbComponent } from './quality-db/quality-db.component';
import { AutonomousMaintananceDbComponent } from '../O3AdministrationComponents/autonomous-maintanance-db/autonomous-maintanance-db.component';
import { ProductionDbComponent } from '../O3AdministrationComponents/production-db/production-db.component';
import { O3AreaChartComponent } from '../components/o3-area-chart/o3-area-chart.component';
import { O3ChartsComponent } from '../components/o3-charts/o3-charts.component';
import { ChartsModule } from 'ng2-charts';
import { LineChartComponent } from '../components/line-chart/line-chart.component';
import { PerformanceAnalysisComponent } from './performance-analysis/performance-analysis.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { O3PercentageGraphComponent } from '../components/o3-percentage-graph/o3-percentage-graph.component';
import { GeneralCategoryComponent } from '../General Category/general-category/general-category.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { ChartModule, HIGHCHARTS_MODULES } from 'angular-highcharts';
import { AgGridModule } from 'ag-grid-angular';
import { TooltipModule } from 'primeng/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BatchReportComponent } from './batch-report/batch-report.component';
import { WholesomeFoodReportComponent } from './wholesome-food-report/wholesome-food-report.component';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { ButtonEditRendererComponent } from '../components/button-edit-render.components';
import { ButtonDeleteRendererComponent } from '../components/button-delete-render.components';
import { ButtonSelectRendererComponent } from '../components/button-select-render.components';
import { NewSfdcComponent } from '../ProductionOrderComponents/new-sfdc/new-sfdc.component';
import { ButtonViewRendererComponent } from '../components/button-view-render.components';
import { ButtonPrintRendererComponent } from '../components/button-print-render.components';
import { EventConfigurationComponent } from '../O3AdministrationComponents/ManufacturingAdminComponents/event-configuration/event-configuration/event-configuration.component';
import { BatchReportOutputComponent } from './batch-report-output/batch-report-output.component';
import { TranslateModule } from '@ngx-translate/core';
import { SfdcNewComponent } from '../ProductionOrderComponents/sfdc-new/sfdc-new.component';
import { DatePickerComponent } from '../components/date-picker.components';
import { CustomLoadingCellRenderer } from '../aggrid custom/custom-loading-cell-renderer.component';
import { LanguageMasterComponent } from './language-master/language-master.component';
import { ButtonSaveRendererComponent } from '../components/button-save-render.components';
import { PalletComponent } from './pallet/pallet.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import stock from 'highcharts/modules/stock.src';
import more from 'highcharts/highcharts-more.src';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ProductCostConfigurationComponent } from './product-cost-configuration/product-cost-configuration.component';
import { CitiesAndCountriesComponent } from '../O3AdministrationComponents/CitiesAndCountries/CitiesAndCountries.component';
import { KpiTargetDownloadComponent } from './kpi-target-download/kpi-target-download.component';
import { MultiSelectModule } from 'primeng/multiselect';
// import { CustomerProfileUploadComponent } from '../quality-management/ncr-ccr-management/customerProfileUpload/customerProfileUpload.component';
// import { CustomerSurveyComponent } from '../quality-management/ncr-ccr-management/customer-survey/customer-survey.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
// import { ImmediateActionComponent } from '../quality-management/ncr-ccr-management/immediate-action/immediate-action.component';
import { UserActionsComponent } from '../user-actions/user-actions.component';
import { NgxMatSelectModule } from '../ngx-mat-select/ngx-mat-select.module';
import { InputReportComponent } from './input-report/input-report.component';
import { UserLicenseComponent } from '../O3AdministrationComponents/user-license/user-license.component';
import { GroupLicenseComponent } from '../O3AdministrationComponents/group-license/group-license.component';
import { BtnCellRendererNewSFDC } from '../btn-cell-rendererNewSFDC';
// import { CustomerSurveyDbComponent } from '../quality-management/ncr-ccr-management/customer-survey-db/customer-survey-db.component';
import { ErpMachineMappingComponent } from './erp-machine-mapping/erp-machine-mapping.component';
import { ErpPlantMappingComponent } from './erp-plant-mapping/erp-plant-mapping.component';
import { ErpProductionOrderComponent } from './erp-production-order/erp-production-order.component';
// import { SortingReportComponent } from '../quality-management/ncr-ccr-management/sorting-report/sorting-report.component';
import { AngularImageViewerModule } from 'angular-x-image-viewer';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { WhatAppConfigComponent } from '../O3AdministrationComponents/what-app-config/what-app-config.component';
import { generalSubDept } from '../General Category/general-subDepartment/generalSubDept.component';
import { BtnCellRendererWaste } from '../btnCellRendererWaste';
import { BtnCellRendererWasteHistory } from '../btnCellRendererWasteHistory';
import { WasteDetailComponent } from '../ProductionOrderComponents/waste-detail/waste-detail.component';
import { SharedModule } from '../user-management/shared/shared.module';
import { DatepickerService } from 'src/backend/services/datepicker.service';
import { AddActionModalComponent } from './addActionModal/addActionModal.component';
import { FormViewerComponent } from './form-viewer/form-viewer.component';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { CustomDateFormatService } from 'src/backend/services/custom-date-format.service';
import { ContextMenuModule } from 'primeng/contextmenu';
import { ActionModalComponent } from './Action-modal/Action-modal.component';
export function highchartsModules() {
  // apply Highcharts Modules to this array
  return [stock, more];
}
@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild({
      extend: true,
    }),
    NgxDropzoneModule,
    ChartsModule,
    ChartModule,
    AngularImageViewerModule,
    NgxDocViewerModule,
    NgApexchartsModule,
    NgxMatSelectModule,
    MatSlideToggleModule,
    NgxMatSelectSearchModule,
    HomeRoutingModule,
    MaterialModule,
    MatMenuModule,
    MatButtonModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatTreeModule,
    MatCardModule,
    AgGridModule,
    MatSelectModule,
    MatNativeDateModule,
    MatDatepickerModule,
    NgxDaterangepickerMd.forRoot(),
    MatDialogModule,
    NgxMaterialTimepickerModule,
    MatExpansionModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    TreeModule,
    DropdownModule,
    NgxSpinnerModule,
    TooltipModule,
    MatTooltipModule,
    HighchartsChartModule,
    NzDatePickerModule,
    MatCheckboxModule,
    MultiSelectModule,
    NgxMatSelectModule,
    NgxDaterangepickerMd.forRoot(),
    // tslint:disable-next-line:max-line-length
    AgGridModule.withComponents([
      ButtonEditRendererComponent,
      ButtonDeleteRendererComponent,
      ButtonSelectRendererComponent,
      ButtonViewRendererComponent,
      ButtonPrintRendererComponent,
      DatePickerComponent,
      CustomLoadingCellRenderer,
      ButtonSaveRendererComponent,
    ]),
    SharedModule,
    ContextMenuModule
  ],
  declarations: [
    ButtonEditRendererComponent,
    ButtonDeleteRendererComponent,
    ButtonSelectRendererComponent,
    ButtonViewRendererComponent,
    ButtonPrintRendererComponent,
    BtnCellRendererNewSFDC,
    DatePickerComponent,
    ButtonSaveRendererComponent,
    HomeComponent,
    PlantModelComponent,
    OeeConfigurationComponent,
    OrderProcessingComponent,
    GeneralAreaComponent,
    generalSubDept,
    GeneralDepartmentComponent,
    GeneralShiftComponent,
    GeneralCategoryComponent,
    ShopFloorDataComponent,
    SfdcConfigurationComponent,
    MachineboardComponent,
    MachineParametersComponent,
    CrewSchedulingComponent,
    WhatAppConfigComponent,
    AvailabilityAnalysisComponent,
    CuAnalysisComponent,
    QualityAnalysisComponent,
    UseraccessComponent,
    QualityDbComponent,
    SafetyDbComponent,
    AutonomousMaintananceDbComponent,
    ProductionDbComponent,
    O3AreaChartComponent,
    O3ChartsComponent,
    LineChartComponent,
    PerformanceAnalysisComponent,
    O3PercentageGraphComponent,
    BatchReportComponent,
    AddActionModalComponent,
    ActionModalComponent,
    BatchReportOutputComponent,
    WholesomeFoodReportComponent,
    NewSfdcComponent,
    EventConfigurationComponent,
    SfdcNewComponent,
    CustomLoadingCellRenderer,
    LanguageMasterComponent,
    PalletComponent,
    ProductCostConfigurationComponent,
    CitiesAndCountriesComponent,
    KpiTargetDownloadComponent,
    // CustomerProfileUploadComponent,
    // CustomerSurveyComponent,
    // ImmediateActionComponent,
    // SortingReportComponent,
    UserActionsComponent,
    KpiTargetDownloadComponent,
    InputReportComponent,
    UserLicenseComponent,
    GroupLicenseComponent,
    // CustomerSurveyDbComponent,
    ErpMachineMappingComponent,
    ErpPlantMappingComponent,
    ErpProductionOrderComponent,
    BtnCellRendererWaste,
    BtnCellRendererWasteHistory,
    WasteDetailComponent,
    FormViewerComponent
  ],
  exports: [O3PercentageGraphComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    { provide: HIGHCHARTS_MODULES, useFactory: highchartsModules }, // add as factory to your providers
    { provide: DateAdapter, useClass: DatepickerService },
    { provide: DateAdapter, useClass: CustomDateFormatService }


  ],
})
export class HomeModule { }
